<template>
  <div>
    <template v-for="(loan, index) in facility.getFunding().loans">
      <BaseCard closed collapsible collapsible-caret :key="index">
        <template v-slot:header>
          Daily Interest for {{ ordinal(index) }} Loan
        </template>
        <BaseTable bordered>
          <colgroup>
            <col width="30%"/>
            <col width="30%"/>
            <col width="40%"/>
          </colgroup>
          <thead>
            <tr>
              <th>Date</th>
              <th>Compounded</th>
              <th>Amount</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(row, key) in facility.projectedDailyInterest()[index]" :key="key">
              <td>{{ toDate(row.date) }}</td>
              <td>{{ row.interestCompounded ? 'Yes' : 'No' }}</td>
              <td>{{ toCurrency(row.amount.toFixed(2)) }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th colspan="2">Total Interest</th>
              <th>{{ toCurrency(facility.aggregateInLoan(facility.projectedDailyInterest()[index])) }}</th>
            </tr>
          </tfoot>
        </BaseTable>
      </BaseCard>
    </template>
  </div>
</template>

<script>
import { Formatting } from '@/mixins'

import BaseCard from './BaseCard.vue'
import BaseTable from './BaseTable.vue'

export default {
  name: 'FacilityDailyInterest',

  mixins: [Formatting],

  components: {
    BaseCard,
    BaseTable
  },

  props: {
    facility: Object
  },

  methods: {
    ordinal (index) {
      const number = this.$_.toNumber(index) + 1
      const ordinal = this.toWordsOrdinal(number)

      return this.$_.upperFirst(ordinal)
    }
  }
}
</script>
